import React from 'react';

const DuaCard = ({ title, arabic, urdu, reference }) => {
  return (
    <>
      {/* =========================================
          DUA SECTION CSS (App.css se yahan laya gaya hai)
          ========================================= */}
      <style>{`
        .premium-dua-category { margin-bottom: 16px; }
        
        .dua-category-header {
          background: var(--glass-bg); 
          border: 1px solid var(--gold-dim);
          border-radius: 16px; 
          padding: 18px 20px;
          display: flex; 
          flex-direction: row-reverse; /* ✅ Arrow left, Text right */
          justify-content: space-between; 
          align-items: center;
          cursor: pointer; 
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease; 
        }
        
        .dua-category-header:hover {
          background: rgba(212, 175, 55, 0.1); 
          border-color: var(--gold-primary);
          transform: translateY(-2px); 
          box-shadow: 0 8px 20px rgba(212, 175, 55, 0.15);
        }
        
        .dua-category-title {
          font-family: 'Noto Nastaliq Urdu', serif; 
          font-size: 1.35rem; 
          font-weight: 700;
          color: var(--gold-shiny); 
          text-shadow: 0 0 10px var(--gold-glow);
          text-align: right; 
          flex: 1; 
        }
        
        .gold-icon { 
          color: var(--gold-primary); 
          transition: transform 0.3s ease; 
          margin-right: 15px; 
        }
        
        .dua-category-content { padding: 15px 0 5px 0; }
        
        .premium-dua-card {
          background: var(--bg-card); 
          border: 1px dashed var(--gold-dim);
          border-radius: 16px; margin-bottom: 15px; overflow: hidden;
          box-shadow: inset 0 0 15px rgba(0,0,0,0.03), 0 5px 20px var(--glass-shadow);
          transition: transform 0.3s ease, border-color 0.3s ease;
        }
        
        .premium-dua-card:hover {
          transform: translateY(-2px); border-color: var(--gold-primary);
          box-shadow: inset 0 0 20px rgba(212, 175, 55, 0.05), 0 8px 25px rgba(0,0,0,0.1);
        }
        
        .dua-card-title-box {
          background: linear-gradient(270deg, rgba(212, 175, 55, 0.15), transparent);
          border-bottom: 1px solid var(--glass-border); padding: 12px 15px; text-align: right;
        }
        
        .dua-card-title-urdu {
          margin: 0; font-family: 'Noto Nastaliq Urdu', serif; font-size: 1.25rem;
          color: var(--gold-primary); font-weight: 700;
        }
        
        .dua-card-body-premium { padding: 20px 15px; text-align: right; direction: rtl; }
        
        .dua-arabic-text {
          font-family: 'Scheherazade New', 'Amiri', serif; font-size: 2.3rem;
          color: var(--text-primary); line-height: 2.3; margin: 0 0 20px 0;
          text-shadow: 0 0 8px rgba(255, 255, 255, 0.1);
        }
        
        [data-theme='light'] .dua-arabic-text { color: #000000; text-shadow: none; }
        
        .dua-urdu-text {
          font-family: 'Noto Nastaliq Urdu', serif; font-size: 1.15rem;
          color: var(--text-secondary); line-height: 2.4; margin: 0;
        }
      `}</style>

      {/* =========================================
          DUA CARD HTML COMPONENT
          ========================================= */}
      <div className="premium-dua-card">
        <div className="dua-card-title-box">
           <h3 className="dua-card-title-urdu">
             {title}
           </h3>
        </div>
        
        <div className="dua-card-body-premium">
          <p className="dua-arabic-text" dir="rtl">
            {arabic}
          </p>
          <p className="dua-urdu-text" dir="rtl">
            {urdu}
          </p>
          {reference && (
            <p style={{ fontSize: '0.6rem', color: 'var(--text-muted)', textAlign: 'right', margin: '4px 0 0 0' }} dir="rtl">
              {reference}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default DuaCard;